import React from 'react';
import { useNavigate } from 'react-router-dom';
import HomeTeamCard from '../components/HomeTeamCard';
import type { IMyTeam } from '../../myTeam/types/myTeam';
import { IoMdAdd } from 'react-icons/io';
import './MyTeamsSection.scss';

interface MyTeamsSectionProps {
  teams: IMyTeam[];
}

const MyTeamsSection: React.FC<MyTeamsSectionProps> = ({ teams }) => {
  const navigate = useNavigate();

  const handleCreateTeam = () => {
    navigate('/my-team');
  };

  return (
    <section className="logged-home-my-teams">
      <h2 className="logged-home-my-teams-title">My Teams,</h2>
      <div className="logged-home-my-teams-wrapper">
        <div className="logged-home-my-teams-carousel">
          {teams.map((team) => (
            <div key={team.teamId} className="logged-home-my-teams-carousel-item">
              <HomeTeamCard team={team} />
            </div>
          ))}
        </div>
        <div className="logged-home-my-teams-create logged-home-my-teams-create--static">
          <div className="logged-home-create-team-card">
            <div className="logged-home-create-team-card-icon">
              <IoMdAdd size={20} className="icon" />
            </div>
            <div className="logged-home-create-team-card-content">
              <h3 className="logged-home-create-team-card-title">Create New Team</h3>
              <p className="logged-home-create-team-card-subtitle">
                Start Organizing Your Cricket League.
              </p>
            </div>
            <button
              type="button"
              className="logged-home-create-team-card-btn"
              onClick={handleCreateTeam}
            >
              Create Team
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MyTeamsSection;
